/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { SegmentedControl } from '../ui';

const SectionButtonGroups = ({ buttonGroup, items, onChange }) => {
  const [activeType, setActiveType] = useState(buttonGroup);

  const handleClick = type => {
    setActiveType(type);
    onChange(type);
    console.log(`${type} button clicked`);
  };

  useEffect(() => {
    setActiveType(buttonGroup);
  }, [buttonGroup]);

  return (
    <SegmentedControl items={items} value={activeType} onChange={handleClick} />
  );
};

export default SectionButtonGroups;
